import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

type UseEstablishmentUsersProps<T> = {
  filters?: {
    search?: string
    companyId?: string
    page?: number
    roleId?: string
    status?: string
  }
  mapper?: (data: any) => T,
}

export const useEstablishmentUsers = <T,>({
  filters: { search = '', page, companyId, roleId, status } = {},
  mapper = Mapper.default<T>(),
}: UseEstablishmentUsersProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['establishmentUsers', search, page, companyId, roleId, status],
    queryFn: () => {
      return privateAxios.get('/establishment/users', {
        params: {
          search,
          page,
          'q[company_id_eq]': companyId,
          'q[role_id_eq]': roleId,
          'q[status_eq]': status,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
